export default __webpack_public_path__ + "static/bg-texture-6c18352e19d1196ee0f742918784fd50.png";